/* unplugin-vue-components disabled */import script from "./UserDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetails.vue?vue&type=script&setup=true&lang=js"

import "./UserDetails.vue?vue&type=style&index=0&id=3783d5be&lang=scss"

const __exports__ = script;

export default __exports__